/*  :
Example:

<button type="button" data-dialog="dialog-1" aria-controls="dialog-1">Open Dialog</button>
<dialog id="dialog-1" class="z-10 p-8 max-w-md" data-isModal>
    <button type="button" class="absolute top-4 right-4" aria-label="close dialog" data-dialog-close autofocus>x</button>
    <h2>Dialog Headline</h2>
    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Atque dolor consequuntur beatae voluptatem qui accusantium, modi laboriosam a expedita, adipisci officiis quas. Reiciendis sunt molestias quaerat deleniti exercitationem. Veritatis recusandae unde accusamus voluptatum, mollitia laboriosam aperiam repellat suscipit harum sequi, tempore reiciendis vero aspernatur eos. Maxime ipsa sint ex explicabo.</p>
</dialog>

*/

const dialogBtns = document.querySelectorAll("[data-dialog]");

function dialog() {
    if (dialogBtns) {
        dialogBtns.forEach((e) => {
            const showBtn = e;
            const dialog = document.getElementById(showBtn.getAttribute('data-dialog'));
            if (dialog) {
                const closeBtn = dialog.querySelector("[data-dialog-close]");
                showBtn.addEventListener("click", () => {
                    if (dialog.hasAttribute("open")) {
                        dialog.close();
                    } else{
                        if (dialog.hasAttribute("data-isModal")) {
                            dialog.showModal();
                        } else {
                            dialog.show();
                        }
                    }
                });
                if (closeBtn) {
                    closeBtn.addEventListener("click", () => {
                        dialog.close();
                    });
                }
            }
        });
    }
}

export { dialog };